import { memo, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlRoomTypeListRequest } from "../../models/service-models/hotel/RoomTypeListRequest";
import { DefinitionService } from "../../services/DefinitionService";

export type RoomTypeSelectProps = {
    onDeselect?: Function;
    onChange?: Function;
    selectedHotel?: string;
    defaultValue?:  string | string[];
    excludedValue?: string;
    mode?: 'multiple' | 'tags' | undefined;
}


export const RoomTypeSelect = memo(function RoomTypeSelect(props: RoomTypeSelectProps) {
    const { t } = useTranslation();
    const [roomTypeListRequest, setRoomTypeListRequest] = useState<mdlRoomTypeListRequest>({ pageSize: 0 });

    useEffect(() => {
        if (!data)
            refetch();
    }, [props]);

    const {
        data: data,
        isLoading: isLoading,
        refetch: refetch,
    } = useQuery(
        ["getRoomTypes", props.selectedHotel],
        () => {
            if (props.selectedHotel)
                return DefinitionService.RoomTypeList({ ...roomTypeListRequest });
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!props.selectedHotel
        }
    );

    return (
        <>
            <Select
                style={{ width: "100%" }}
                loading={isLoading}
                size="middle"
                mode={props.mode}
                onDeselect={(value: string) => props.onDeselect ? props.onDeselect(value) : undefined}
                defaultValue={props.defaultValue}
                onSelect={(value: string) => props.onChange ? props.onChange(value,data?.body?.data?.find((x:any) => x.roomTypeId == value)?.name) : undefined}
                showSearch
                placeholder={t("common.chooseRoomType")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data?.body?.data?.map((h:any) => Object.assign(h, {
                    label: h.name,
                    value: h.roomTypeId
                })).filter((x) => !props.excludedValue || (props.excludedValue && x.value != props.excludedValue))}
            />
        </>
    )
})